import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { initialState, reducer } from './reducer';

function configureStore() {
    const store = createStore(
        persistReducer(
            {
                key: 'root',
                storage,
                whitelist: ['user'],
            },
            reducer
        ),
        initialState
    );

    localStorage.setItem('sessionId', store.getState().user?.sessionId ?? '');

    const persistor = persistStore(store, null, () => {
        localStorage.setItem('sessionId', store.getState().user?.sessionId ?? '');
    });

    return { store, persistor };
}

export default configureStore;
